import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import api, { formatApiError } from "../../lib/api";
import { inputCls, labelCls } from "./shared";

const newVideo = () => ({ id: crypto.randomUUID(), title: "", vimeo_url: "" });

export default function EditionsTab() {
  const [editions, setEditions] = useState([]);
  const [form, setForm] = useState({ title: "", year: "", description: "" });
  const [videos, setVideos] = useState([newVideo()]);

  const load = useCallback(() => {
    api.get("/editions").then((r) => setEditions(r.data)).catch((e) => console.error("Falha ao carregar edições:", e));
  }, []);
  useEffect(() => { load(); }, [load]);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/editions", {
        ...form,
        videos: videos.filter((v) => v.title && v.vimeo_url).map(({ title, vimeo_url }) => ({ title, vimeo_url })),
      });
      toast.success("Edição cadastrada");
      setForm({ title: "", year: "", description: "" });
      setVideos([newVideo()]);
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const updateVideo = (vidId, field, value) =>
    setVideos(videos.map((x) => (x.id === vidId ? { ...x, [field]: value } : x)));

  return (
    <div className="space-y-6">
      <form onSubmit={add} className="card-metric space-y-4">
        <h3 className="text-lg font-semibold text-white">Cadastrar edição anterior</h3>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="sm:col-span-2">
            <label className={labelCls}>Título da edição</label>
            <input required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })}
              className={inputCls} placeholder="Ex: Pregoeiros Summit 2025 - São Paulo" data-testid="edition-title-input" />
          </div>
          <div>
            <label className={labelCls}>Ano</label>
            <input required value={form.year} onChange={(e) => setForm({ ...form, year: e.target.value })}
              className={inputCls} placeholder="2025" data-testid="edition-year-input" />
          </div>
        </div>
        <div>
          <label className={labelCls}>Descrição</label>
          <input value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className={inputCls} data-testid="edition-description-input" />
        </div>
        <div className="space-y-3">
          <label className={labelCls}>Vídeos do Vimeo</label>
          {videos.map((v, i) => (
            <div key={v.id} className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <input value={v.title} placeholder="Título do vídeo"
                onChange={(e) => updateVideo(v.id, "title", e.target.value)}
                className={inputCls} data-testid={`edition-video-title-${i}`} />
              <input value={v.vimeo_url} placeholder="https://vimeo.com/..."
                onChange={(e) => updateVideo(v.id, "vimeo_url", e.target.value)}
                className={`${inputCls} font-data text-sm`} data-testid={`edition-video-url-${i}`} />
            </div>
          ))}
          <button type="button" onClick={() => setVideos([...videos, newVideo()])}
            className="btn-ghost text-sm inline-flex items-center gap-1" data-testid="edition-add-video-btn">
            <Plus size={14} /> Adicionar vídeo
          </button>
        </div>
        <button type="submit" className="btn-primary" data-testid="edition-save-btn">Cadastrar edição</button>
      </form>

      <div className="space-y-3">
        {editions.map((ed) => (
          <div key={ed.id} className="card-metric flex items-start justify-between gap-3" data-testid={`admin-edition-${ed.year}`}>
            <div>
              <p className="font-semibold text-white">{ed.title} <span className="text-[#F5A623] font-data text-xs ml-2">{ed.year}</span></p>
              <p className="text-xs text-slate-400 mt-1">{ed.videos.length} vídeo(s)</p>
            </div>
            <button onClick={async () => { if (window.confirm("Excluir edição?")) { await api.delete(`/admin/editions/${ed.id}`); load(); } }}
              className="p-1.5 text-red-400 hover:bg-red-500/10 rounded" data-testid={`delete-edition-${ed.year}`}>
              <Trash2 size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
